import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, map, catchError, first } from 'rxjs';
import { Store } from '@ngrx/store';

import { UserData } from '@deltager/organizers/admin/shared/models/LoginData';
import { AppNotificationsService } from '../../services/app-notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { OrganizerSettings } from '@deltager/organizers/admin/shared/models/OrganizerSettings';
import { selectOrganizer } from '@deltager/organizers/admin/redux/root.state';
import { AppSettingsService } from '../../app-settings/app-settings.service';

@Injectable()
export class DiscountsResolver {
  constructor(
    private router: Router,
    private notificationService: AppNotificationsService,
    private translateService: TranslateService,
    private store: Store<{ organiser: OrganizerSettings }>,
    private appSettingsService: AppSettingsService,
  ) {}

  resolve(): Observable<UserData> {
    return this.store.select(selectOrganizer).pipe(
      first(o => !!o),
      map(organizer => {
        if (!organizer.modules?.vouchers) {
          this.notificationService.sendError({
            message: this.translateService.instant('discounts.disabled_in_organizer'),
          });

          this.router.navigate(['/events']);
          return null;
        }

        return organizer as unknown as UserData;
      }),
      catchError(() => {
        this.appSettingsService.goToLogin();

        return of(null);
      }),
    );
  }
}
